import { Button } from './ui/button';

/** Google "G" brand mark (inline SVG — lucide has no brand icons). */
const GoogleIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1Z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z" />
    <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38Z" />
  </svg>
);

/**
 * "Continue with Google" — kicks off the Emergent-managed Google OAuth flow.
 * Pass `ssoContext` on the hosted SSO login page so the callback can resume the
 * OAuth2 consent + redirect back to the requesting app after Google sign-in.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export const GoogleAuthButton = ({ label = 'Continue with Google', ssoContext = null, className = '' }) => {
  const handleClick = () => {
    try {
      if (ssoContext) sessionStorage.setItem('sso_pending', JSON.stringify(ssoContext));
      else sessionStorage.removeItem('sso_pending');
    } catch (_) { /* noop */ }
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleClick}
      className={`w-full border-zinc-300 ${className}`}
      data-testid="google-auth-btn"
    >
      <GoogleIcon />
      <span className="ml-2">{label}</span>
    </Button>
  );
};
